import { createSelector } from "reselect";

const getTemplates = (state) => state.templates.data;
const getSelectedTemplateId = (state) => state.templates.selectedTemplate;

export const getSelectedTemplate = createSelector(
  [getTemplates, getSelectedTemplateId],
  (templates, selectedTemplateId) => {
    const template = templates.find(
      (template) => template.id === selectedTemplateId
    );
    const result = { systemText: "", templateMessage: "", title: "" };
    if (template) {
      result.systemText = template.system;
      result.templateMessage = template.message;
      result.title = template.title;
    }
    return result;
  }
);
